import * as React from 'react';

import getDisplayName from 'authentication/helpers/getDisplayName';
import { DocumentTitle } from 'components/common';
import WizardPageHeader from 'components/authentication/directoryServices/ldap/WizardPageHeader';
import SectionComponent from 'components/common/Section/SectionComponent';
import LicenseCheck from 'license/LicenseCheck';
import { AUTH_SERVICE_TYPE } from 'authentication/components/saml/constants';
import SAMLBackendConfigWizard from 'authentication/components/saml/config/SAMLBackendConfigWizard';

const SAMLBackendCreate = () => {
  const title = `Create ${getDisplayName(AUTH_SERVICE_TYPE)} Authentication Service`;

  return (
    <DocumentTitle title={title}>
      <WizardPageHeader title={title} />
      {/* TODO: The SectionComponent results in a duplicate title. (Same for Okta/OIDC) Can we remove it? */}
      <SectionComponent title={title}>
        <LicenseCheck>
          {({ licenseIsValid }) => <SAMLBackendConfigWizard licenseIsValid={licenseIsValid} />}
        </LicenseCheck>
      </SectionComponent>
    </DocumentTitle>
  );
};

export default SAMLBackendCreate;
